import React from "react";
import Section from "../../Blog/BlogMasonary/Section";
import MasonaryContent from "../../Blog/BlogMasonary/MasonaryContent";

const BlogMasonary = () => {
  document.title =
    "Blog Masonary - Matrix Executive Search Group";

  return (
    <React.Fragment>
      <Section />
      <MasonaryContent />
    </React.Fragment>
  );
};

export default BlogMasonary;
